import { Component, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Observable, fromEvent } from 'rxjs';
import { map, filter, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

@Component({
  selector: 'client-autocomplete-input',
  templateUrl: './client-autocomplete-input.component.html',
  styleUrls: ['./client-autocomplete-input.component.css'],
  standalone: false
})
export class AutoCompleteInputComponent implements OnInit {
  hasSearched: boolean;
  searchQuery: string;
  showSearchResults: boolean;

  @Input() data: any[];
  @Input() minSearchLength = 2;
  @Input() initialQuery: string;
  @Input() searchObs: Observable<any>;
  @Input() isDisabled: boolean;

  @Output() setQuery: EventEmitter<string> = new EventEmitter();
  @Output() setData = new EventEmitter<any>();
  @Output() valueSelected: EventEmitter<string> = new EventEmitter();
  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;

  constructor() {}

  ngOnInit() {
    this.setSearchDebounce();
    this.searchInput.nativeElement.value = this.initialQuery;
  }

  changeQuery(evnt) {
    this.hasSearched = true;
    this.searchQuery = evnt.target.value;
    this.setQuery.emit(this.searchQuery);
    if (!this.searchQuery || this.searchQuery.length < this.minSearchLength) {
      this.data = [];
    } else {
      this.showResults();
    }
  }

  setSearchDebounce() {
    // make sure requests are delayed based on user input
    fromEvent(this.searchInput.nativeElement, 'keyup')
      .pipe(
        map((e: KeyboardEvent) => (e.target as HTMLInputElement).value),
        filter(text => text.length >= this.minSearchLength),
        debounceTime(250),
        distinctUntilChanged(),
        switchMap(() => this.searchObs)
      )
      .subscribe((d: any) => {
        this.setData.emit(d);
      });
  }

  showResults() {
    if (
      this.searchInput.nativeElement === document.activeElement &&
      this.hasSearched &&
      this.searchQuery &&
      this.searchQuery.length >= this.minSearchLength
    ) {
      this.showSearchResults = true;
    } else if (this.showSearchResults) {
      setTimeout(() => (this.showSearchResults = false), 250);
    }
  }

  setValue(id: string, DBA: string, name: string) {
    this.searchInput.nativeElement.value = `${id} - ${DBA || name}`;
    this.valueSelected.emit(id);

    // trigger search event with the full id/name pair
    // in order to narrow down results list
    // to only the selected item
    this.searchInput.nativeElement.dispatchEvent(new KeyboardEvent('keyup'));
  }
}
